import { extend } from "vee-validate";
import { required, confirmed, length, email, integer } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required"
});

extend("integer", {
  ...required,
  message: "This field must be an integer"
});

extend("email", {
  ...email,
  message: "This field must be a valid email"
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match"
});

extend("length", {
  ...length,
  message: "This field must have 2 options"
});
